
import Analysis from '@/components/Company/Analysis'

export default {
    name: 'StockInfo',
    components: {
        Analysis,
    },
}
